import moment from 'moment-timezone';
import { Expression, NamedColumn } from '../../types';
import customHandlers from './custom-formatters/custom-handlers';
import findOperator from './find-operator';
import { utcDateTimeFields } from '../../../shared/material_components/column-filter/helpers';

export default function dateFormatter(
  column: NamedColumn, expression: Expression,
): Expression | null {
  const unsetTimeZone = (date: string): string => {
    const timeZone = moment.tz.guess();
    const momentDate = moment.tz(date, timeZone);
    return moment(momentDate).utc().add(momentDate.utcOffset(), 'm').format();
  };

  const { type } = column;
  const { operator, value } = expression;
  let newValue: string[] | null = null;

  if (!['date', 'timestamp'].includes(type)) {
    return null;
  }

  if (operator) {
    if (operator === 'between' && utcDateTimeFields.includes(column.name) && typeof value[0] === 'string') {
      const zonedDates = expression.value.map((date) => unsetTimeZone(date));
      return { ...expression, field: column.identifier(), value: zonedDates };
    }
    return { ...expression, field: column.identifier() };
  }

  if (typeof value[0] === 'object') {
    newValue = [value[0].value];
  }

  if (typeof value[0] === 'string') {
    const dates = (value as string[])[0].split(', ');

    if (dates.length > 1) { // custom date expression
      const zonedDates = utcDateTimeFields.includes(column.name)
        ? dates.map((date) => unsetTimeZone(date)) : dates;

      return {
        ...expression,
        field: column.identifier(),
        operator: 'between',
        value: zonedDates,
      };
    }
  }
  // @ts-ignore
  const operatorType = findOperator(newValue ?? value[0]);

  if (operatorType) {
    return {
      ...expression,
      field: column.identifier(),
      operator: operatorType.name,
      value: [],
    };
  }
  // @ts-ignore
  return customHandlers(column, expression);
}
